import {ANALYZERS_ROUTES} from "@constants"
import {offices, reports, searchID} from "@signals"
import PageWrapper from "Pages/@PageWrapper"
import {resetCustomFilters, responseData} from "Pages/AnalyzersV2/@signals"
import LorContent from "Pages/AnalyzersV2/Lor/Content"
import LorFilters from "Pages/AnalyzersV2/Lor/Filters"
import React, {useEffect, useState} from "react"
import {createPortal} from "react-dom"
import {useSearchParams, useLocation} from "react-router-dom"
import {useSearchDate} from "../@hooks";
import {AppOfficesBlock} from "../../../@components";
import {Box, Skeleton, Typography} from "@mui/material";
import PageWrapperAnalyzers from "../../@PageWrapper/Actions/Analyzers";
import ReportsAutocomplete from "../../@PageWrapper/Actions/Reports";
import VirtualTourButton, {TourOverlay, TOUR_STEPS} from "./VirtualTour";
import LorDemoData from "./VirtualTour/DemoData";
import { AnalyzerEvolutionModal } from "Pages/AnalyzersV2/@components";
import { demoPopoverOpen } from "./VirtualTour/signals";
import { dsColorNew } from "@palette"


export default function LorAnalyzer() {

	const [ searchParams ] = useSearchParams()
	const location = useLocation()
	const { date, office, isLoading } = useSearchDate()
	const [tourActive, setTourActive] = useState(false)

	useEffect(() => {
		resetCustomFilters()
		searchID.value = searchParams.get("idSearch")
		reports.value = searchParams.get("idReportExecution")
		offices.value = searchParams.get("idOfficePickup")
	}, [location.search])

	return <PageWrapper
		head={`DS Rentacar | ${ANALYZERS_ROUTES.LOR_SUBTITLE}`}
		title={ANALYZERS_ROUTES.TITLE}
		subtitle={ANALYZERS_ROUTES.LOR_SUBTITLE}
		showAnalyzersLinks={true}
		isEmpty={false}
		filters={<LorFilters/>}
		actions={<Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, whiteSpace: 'nowrap' }}>
			{!searchID.value && <Box data-tour-id="tour-report-selector" sx={{ minWidth: { xs: 240, xl: 300 }, mr: { xs: 0.5, xl: 2 } }}>
				<ReportsAutocomplete/>
			</Box>}
			{!!searchID.value && <>
				{isLoading
					? <Skeleton variant='rounded' height={30} sx={{ borderRadius: '8px' }}/>
					:  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start', gap: 1, color: 'secondary.main' }}>
						<AppOfficesBlock sx={{ color: dsColorNew.black }} {...office}  /> -
						<Typography variant="subtitle2" fontWeight='regular'>{date}</Typography>
					</Box>}
			</>}
			<PageWrapperAnalyzers/>
			<VirtualTourButton onClick={() => setTourActive(true)} />
		</Box>}
	>
		<LorContent/>
		{tourActive && !Object.keys(responseData.value || {}).length && <LorDemoData/>}
		{tourActive && !Object.keys(responseData.value || {}).length && <AnalyzerEvolutionModal/>}
		{tourActive && createPortal(
			<TourOverlay steps={TOUR_STEPS} onClose={() => {
				demoPopoverOpen.value = false
				setTourActive(false)
			}} />,
			document.body
		)}
	</PageWrapper>
}
